import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Center, Title } from '@mantine/core'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useMediaQuery } from '@mantine/hooks'
import { useSelector } from 'react-redux'
import { formatNumber } from 'shared/tools/formatNumber'
import { truncateText } from 'shared/tools/truncateText'
import { BorderWindow } from 'shared/ui/BorderWindow/BorderWindow'
import { FinanceCountrySeries } from 'entities/Finance/model/types/finance'
import { getChartCountyData } from '../../model/selectors/getChartCountryData/getChartCountryData'
import { useStyles } from './FinanceCountry.styles'

interface FinanceCountryProps {
    className?: string
}

export const FinanceCountry: FC<FinanceCountryProps> = (props) => {
    const { className } = props

    const { classes } = useStyles()
    const { t } = useTranslation()

    const md = useMediaQuery('(max-width: 992px)')
    const xll = useMediaQuery('(max-width: 1600px)')
    const countryData = useSelector(getChartCountyData)

    const [chartDATA, setChartDATA] = useState<FinanceCountrySeries[]>([])

    useEffect(() => {
        if (countryData !== undefined) {
            const sortedData = countryData
                .map((item) => {
                    return { ...item }
                })
                .sort((a, b) => b.y - a.y)
            setChartDATA(sortedData)
        }
    }, [countryData])

    const options: Highcharts.Options = {
        chart: {
            plotBackgroundColor: '#f8f9fa',
            backgroundColor: '#f8f9fa',
            type: 'pie',
            height: xll ? 500 : 400,
        },
        title: {
            text: undefined,
        },

        accessibility: {
            announceNewData: {
                enabled: true,
            },
        },
        credits: {
            enabled: false,
        },

        plotOptions: {
            pie: {
                innerSize: '80%',
                center: ['50%', '50%'],
            },
            series: {
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
            },
        },
        legend: {
            align: xll ? 'center' : 'right',
            verticalAlign: xll ? 'bottom' : 'middle',
            layout: 'vertical',
            itemStyle: {
                fontSize: '15px',
            },
            maxHeight: 200,
            labelFormatter: function () {
                let point = this as Highcharts.Point
                let name = point.name
                return truncateText(name, 27) + ': ' + formatNumber(point.y) + ' ₽'
            },
        },
        tooltip: {
            headerFormat: undefined,
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> ₽<br/>',
        },
        series: [{ name: 'Brands', data: chartDATA, type: 'pie' }],
    }

    return (
        <BorderWindow>
            <Title order={2} mb={40}>
                Выручка по странам
            </Title>
            <>
                {countryData?.length === 0 ? (
                    <Center fw={600} my={50}>
                        За текущий период график пуст
                    </Center>
                ) : (
                    <HighchartsReact highcharts={Highcharts} options={options} />
                )}
            </>
        </BorderWindow>
    )
}
